<app-dialog-header [title]="title" (onClick)="dialogRef.close(false)"></app-dialog-header>

<div mat-dialog-content fxLayout="column" fxLayoutAlign="start">
    <mat-horizontal-stepper [linear]="true" class="pt-16" labelPosition="bottom" #stepper (selectionChange)="onStepChange($event)">
        <mat-step *ngIf="showFirstStep" [completed]="!!list.length">
            <ng-template matStepLabel>{{ 'GENERAL.LABEL.PARTICIPANTS' | translate }}</ng-template>

            <ng-container *ngIf="list.length">
                <h3 class="mb-8 text-base font-medium text-gray-600">{{ 'GENERAL.LABEL.SELECTED_USERS' | translate }}</h3>
                <mat-chip-set class="chip-list wrap">
                    <mat-chip class="chip maxbrain-500" [removable]="removable" (removed)="removeFromList(item)" *ngFor="let item of list">
                        {{ item.fullName }}
                        <mat-icon matChipRemove *ngIf="removable">cancel</mat-icon>
                    </mat-chip>
                </mat-chip-set>
            </ng-container>

            <div fxLayout="row" fxLayoutAlign="flex-end center" class="mb-12">
                <app-search-outline [searchInput]="searchInput"></app-search-outline>
            </div>

            <div class="w-100-p table-wrapper" *ngIf="dataSource">
                <mat-table #table [dataSource]="dataSource" matSort>
                    <!-- Avatar Column -->
                    <ng-container matColumnDef="avatar">
                        <mat-header-cell *matHeaderCellDef></mat-header-cell>
                        <mat-cell *matCellDef="let user">
                            <div class="relative" #avatarCell>
                                <img class="avatar" *ngIf="user?.avatar.src; else initials" [alt]="user.fullName" [src]="user.avatar.src" />
                                <ng-template #initials>
                                    <div fxLayoutAlign="center center" class="avatar-initials avatar">{{ user.fullName | initials }}</div>
                                </ng-template>
                                <ng-template [onlineStateIndicator]="user.isOnline"> </ng-template>
                            </div>
                        </mat-cell>
                    </ng-container>

                    <!-- First Name Column -->
                    <ng-container matColumnDef="firstName">
                        <mat-header-cell class="narrow" *matHeaderCellDef mat-sort-header> {{ 'GENERAL.PROPERTY.FIRST_NAME' | translate }}</mat-header-cell>
                        <mat-cell *matCellDef="let user" class="narrow">
                            <p #firstNameRow class="text-truncate font-semibold">
                                {{ user.firstName }}
                            </p>
                        </mat-cell>
                    </ng-container>

                    <!-- Last Name Column -->
                    <ng-container matColumnDef="lastName">
                        <mat-header-cell class="narrow" *matHeaderCellDef mat-sort-header>
                            {{ 'GENERAL.PROPERTY.LAST_NAME' | translate }}
                        </mat-header-cell>
                        <mat-cell *matCellDef="let user" class="narrow">
                            <p #lastNameRow class="text-truncate font-semibold">
                                {{ user.lastName }}
                            </p>
                        </mat-cell>
                    </ng-container>

                    <!-- Email Column -->
                    <ng-container matColumnDef="email">
                        <mat-header-cell class="wider" *matHeaderCellDef mat-sort-header fxHide fxShow.gt-xs>
                            {{ 'GENERAL.PROPERTY.EMAIL' | translate }}
                        </mat-header-cell>
                        <mat-cell *matCellDef="let user" fxHide fxShow.gt-xs>
                            <p #lastNameRow class="text-truncate font-semibold">{{ user.email }}</p>
                        </mat-cell>
                    </ng-container>

                    <!-- Buttons Column -->
                    <ng-container matColumnDef="buttons">
                        <mat-header-cell *matHeaderCellDef></mat-header-cell>
                        <mat-cell *matCellDef="let user">
                            <div fxFlex="row" fxLayoutAlign="end center">
                                <app-flat-button [label]="'GENERAL.BUTTON.ADD'" (onClick)="addToList(user)" *ngIf="!user.alreadyMember && !user.selected"></app-flat-button>
                                <p *ngIf="user.alreadyMember">{{ 'GENERAL.LABEL.IN_GROUP' | translate }}</p>
                                <app-white-button [label]="'GENERAL.BUTTON.UNSELECT'" (onClick)="removeFromList(user)" *ngIf="user.selected"></app-white-button>
                            </div>
                        </mat-cell>
                    </ng-container>

                    <mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>
                    <mat-row *matRowDef="let user; columns: displayedColumns" class="user" matRipple> </mat-row>
                </mat-table>
                <mat-paginator persistPageSize="course-offering-participants.add-program-participants-dialog" [length]="totalCount$ | async" [pageSize]="5" [pageSizeOptions]="[5, 10, 25, 50]"> </mat-paginator>
            </div>
        </mat-step>

        <mat-step>
            <ng-template matStepLabel> {{ 'GENERAL.LABEL.EXECUTIONS' | translate }}</ng-template>

            <div *ngIf="programStructuresWithGroups.length; else noProgramStructure">
                <div *ngFor="let programStructureWithGroup of programStructuresWithGroups; let i = index; let isLast = last" [class.mb-32]="!isLast">
                    <h2 class="text-base mb-16">{{ programStructureWithGroup.group.name }}</h2>

                    <div class="p-16 bg-zinc-50">
                        <div
                            fxLayout="row"
                            fxLayoutAlign="flex-start center"
                            class="w-100-p p-16 pb-0 bg-white"
                            *ngFor="let defaultExecutionWithCourseOffering of programStructureWithGroup.structure; let j = index; let isLastExecution = last"
                            [class.mb-8]="!isLastExecution"
                        >
                            <div
                                fxLayout="row"
                                fxLayoutAlign="flex-start center"
                                class="pb-16"
                                *ngIf="
                                    defaultExecutionWithCourseOffering.courseOffering.courseTemplate.kind === ModuleKind.ProgramExecution ||
                                        defaultExecutionWithCourseOffering.courseOffering.courseTemplate.kind === ModuleKind.ProgramTemplate;
                                    else selectRelevantExecution
                                "
                            >
                                <mat-icon class="mr-16" [svgIcon]="defaultExecutionWithCourseOffering.courseOffering.courseTemplate | getModuleIcon"> </mat-icon>

                                <div fxLayout="column">
                                    <h3 class="text-gray-400 mt-0 mb-4">{{ defaultExecutionWithCourseOffering.courseOffering.name }}</h3>
                                    <p class="text-gray-400 my-0">{{ 'PAGE.DIALOG.ADD_PROGRAM_PARTICIPANTS.LABEL.BOOK_TO_PROGRAM' | translate }}</p>
                                </div>
                            </div>

                            <ng-template #selectRelevantExecution>
                                <mat-icon class="mr-16 mb-24" [svgIcon]="defaultExecutionWithCourseOffering.courseOffering.courseTemplate | getModuleIcon"> </mat-icon>

                                <mat-form-field class="w-100-p" (mousedown)="prepareExecutionOptionsLoad(i, j)">
                                    <mat-label>{{ defaultExecutionWithCourseOffering.courseOffering.name }}</mat-label>
                                    <mat-select
                                        #executionSelect
                                        [formControl]="getFormControl(i, j)"
                                        [panelClass]="'add-program-participants-execution-panel'"
                                        (openedChange)="onFormControlClick(i, j, $event)"
                                    >
                                        <!-- Keep selected value visible in the closed select before first fetch -->
                                        <ng-container *ngIf="!defaultExecutionWithCourseOffering.hasLoadedOptions && !defaultExecutionWithCourseOffering.isLoading">
                                            <mat-option
                                                *ngFor="let option of defaultExecutionWithCourseOffering.options"
                                                [value]="option.id"
                                                [disabled]="!isExecutionSelectable(option)"
                                            >
                                                {{ option.name }}
                                            </mat-option>
                                        </ng-container>

                                        <mat-option
                                            *ngIf="
                                                defaultExecutionWithCourseOffering.hasLoadedOptions &&
                                                !defaultExecutionWithCourseOffering.isLoading &&
                                                executionSelect.value
                                            "
                                            [value]="null"
                                        >
                                            {{ 'GENERAL.LABEL.CLEAR_SELECTION' | translate }}
                                        </mat-option>

                                        <mat-option *ngIf="defaultExecutionWithCourseOffering.isLoading" disabled class="execution-options-loading">
                                            <div class="execution-options-shimmer">
                                                <div class="shimmer-card table animate mb-8"></div>
                                                <div class="shimmer-card table animate mb-8"></div>
                                                <div class="shimmer-card table animate"></div>
                                            </div>
                                        </mat-option>

                                        <ng-container *ngIf="defaultExecutionWithCourseOffering.hasLoadedOptions && !defaultExecutionWithCourseOffering.isLoading">
                                            <mat-option
                                                *ngFor="let option of defaultExecutionWithCourseOffering.options"
                                                [value]="option.id"
                                                [disabled]="!isExecutionSelectable(option)"
                                            >
                                                <div
                                                    fxLayout="row"
                                                    fxLayoutAlign="space-between center"
                                                    class="execution-option-row"
                                                    [class.execution-option-disabled]="!isExecutionSelectable(option)"
                                                >
                                                    <div fxLayout="column" fxLayoutAlign="start start" class="execution-option-main">
                                                        <span class="execution-option-name">{{ option.name }}</span>
                                                        <span class="execution-option-meta text-xs" *ngIf="option.startDate">
                                                            ({{ option.startDate | date: 'shortDate' }} - {{ option.endDate | date: 'shortDate' }})
                                                        </span>
                                                        <span class="execution-option-meta text-xs" *ngIf="!option.startDate">
                                                            ({{ option.version || '-' }})
                                                        </span>
                                                    </div>
                                                    <div fxLayout="row" fxLayoutAlign="end center" class="execution-option-tags text-sm">
                                                        <span *ngIf="getDisabledExecutionSuffixLabel(option)" class="execution-option-status mr-8 whitespace-nowrap">
                                                            {{ getDisabledExecutionSuffixLabel(option) | translate }}
                                                        </span>
                                                        <span
                                                            *ngIf="option.isDefault"
                                                            class="execution-option-default bg-primary-50 rounded-full px-16 py-8 text-sm text-primary-600 font-medium whitespace-nowrap"
                                                        >
                                                            {{ 'PAGE.DIALOG.EDIT_RELEVANT_EXECUTIONS.LABEL.DEFAULT_EXECUTION' | translate }}
                                                        </span>
                                                    </div>
                                                </div>
                                            </mat-option>
                                        </ng-container>
                                    </mat-select>
                                </mat-form-field>
                            </ng-template>
                        </div>
                    </div>
                </div>
            </div>

            <ng-template #noProgramStructure>
                <div fxLayout="column" fxLayoutAlign="center center" class="no-progress-container p-32">
                    <mat-icon class="participant-view-illustration" svgIcon="program_structure_illustration"></mat-icon>
                    <h3 class="mt-8 mb-4 text-2xl font-medium">
                        {{ 'GENERAL.LABEL.NO_PROGRAM_STRUCTURE' | translate }}
                    </h3>
                    <p class="mt-0 mb-16 text-base font-normal">
                        {{ 'PAGE.DIALOG.ADD_PROGRAM_PARTICIPANTS.LABEL.NO_PROGRAM_STRUCTURE' | translate }}
                    </p>
                </div>
            </ng-template>
        </mat-step>

        <mat-step>
            <ng-template matStepLabel> {{ 'GENERAL.LABEL.CONFIRMATION' | translate }}</ng-template>

            <div *ngIf="!isProgramStructuresWithGroupsLoading; else shimmer">
                <div *ngIf="participantsExecutionChanges.length; else alreadyBooked">
                    <h2 class="font-medium text-base text-gray-600">
                        {{
                            'PAGE.DIALOG.ADD_PROGRAM_PARTICIPANTS.LABEL.EXISTING_COURSE_BOOKING_DETECTED'
                                | translate: { changesCount: participantsExecutionChanges.length || 0 }
                        }}
                    </h2>
                    <p class="text-gray-600 mb-24">
                        {{ 'PAGE.DIALOG.ADD_PROGRAM_PARTICIPANTS.LABEL.EXISTING_COURSE_BOOKING_DETECTED_DESC' | translate }}
                    </p>

                    <div fxLayout="column" class="participant-execution-changes-container pr-8">
                        <div
                            fxLayout="row"
                            fxLayoutAlign="start center"
                            class="py-12 px-16 bg-gray-100 rounded"
                            fxLayoutGap="16px"
                            *ngFor="let executionChange of participantsExecutionChanges; let isLast = last"
                            [class.mb-8]="!isLast"
                        >
                            <div class="ellipsis-container min-w-0" fxLayout="row" fxLayoutAlign="flex-start center" fxFlex="0 0 240px">
                                <div class="relative">
                                    <img
                                        class="avatar"
                                        *ngIf="executionChange.participant.profilePicture?.url; else initials"
                                        [alt]="executionChange.participant.firstName"
                                        [src]="executionChange.participant.profilePicture?.url"
                                    />
                                    <ng-template #initials>
                                        <div fxLayoutAlign="center center" class="avatar-initials avatar">{{ executionChange.participant.fullName | initials }}</div>
                                    </ng-template>
                                </div>

                                <div fxLayout="column" class="ellipsis-container min-w-0">
                                    <span class="full-name text-truncate" [tooltipIfTruncated]="executionChange.participant.fullName">{{
                                        executionChange.participant.fullName
                                    }}</span>
                                    <span class="email text-truncate text-gray-600" *ngIf="!hideEmail" [tooltipIfTruncated]="executionChange.participant.email">{{
                                        executionChange.participant.email
                                    }}</span>
                                </div>
                            </div>

                            <div class="bg-white rounded p-12 min-w-0" fxLayout="column" fxFlex="1 1 auto">
                                <div fxLayout="row" fxLayoutAlign="start center" class="mb-12">
                                    <span class="inline-flex items-center min-w-0">
                                        <mat-icon class="icon-18 mr-8" [svgIcon]="executionChange.selected | getModuleIcon"></mat-icon>
                                        <span
                                            class="text-gray-600 font-medium text-truncate"
                                            [tooltipIfTruncated]="executionChange.selected.courseOffering?.name || executionChange.selected.name"
                                        >
                                            {{ executionChange.selected.courseOffering?.name || executionChange.selected.name }}
                                        </span>
                                    </span>
                                </div>

                                <div fxLayout="row" fxLayoutGap="12px">
                                    <div class="bg-zinc-50 rounded p-12 min-w-0" fxLayout="column" fxFlex="1 1 50%">
                                        <span class="text-gray-600 font-medium mb-8">
                                            <ng-container *ngIf="executionChange.alreadyBooked.startDate; else alreadyBookedVersion">
                                                {{ executionChange.alreadyBooked.startDate | date: 'shortDate' }} -
                                                {{ executionChange.alreadyBooked.endDate | date: 'shortDate' }}
                                            </ng-container>
                                            <ng-template #alreadyBookedVersion>
                                                {{ executionChange.alreadyBooked.version || '-' }}
                                            </ng-template>
                                        </span>
                                        <mat-slide-toggle class="booking-toggle" [checked]="false" [disabled]="true" labelPosition="before">
                                            {{ 'PROGRAMS.BUTTON.ALREADY_BOOKED' | translate }}
                                        </mat-slide-toggle>
                                    </div>

                                    <div class="bg-zinc-50 rounded p-12 min-w-0" fxLayout="column" fxFlex="1 1 50%">
                                        <span class="text-gray-600 font-medium mb-8">
                                            <ng-container *ngIf="executionChange.selected.startDate; else selectedVersion">
                                                {{ executionChange.selected.startDate | date: 'shortDate' }} -
                                                {{ executionChange.selected.endDate | date: 'shortDate' }}
                                            </ng-container>
                                            <ng-template #selectedVersion>
                                                {{ executionChange.selected.version || '-' }}
                                            </ng-template>
                                        </span>
                                        <mat-slide-toggle
                                            class="booking-toggle"
                                            color="primary"
                                            labelPosition="before"
                                            [checked]="executionChange.selected.isSelected"
                                            (change)="onBookingToggleChange(executionChange, $event.checked)"
                                        >
                                            {{
                                                (executionChange.selected.isSelected ? 'GENERAL.LABEL.BOOK_USER' : 'GENERAL.LABEL.DONT_BOOK_USER') | translate
                                            }}
                                        </mat-slide-toggle>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <ng-template #alreadyBooked>
                    <div fxLayout="column" fxLayoutAlign="center center" class="py-40">
                        <mat-icon class="participant-view-illustration mb-4" svgIcon="checkmark_illustration"></mat-icon>
                        <h2 class="text-base font-medium text-gray-600 text-center">{{ 'PAGE.DIALOG.ADD_PROGRAM_PARTICIPANTS.LABEL.ALL_PARTICIPANTS_BOOKED' | translate }}</h2>
                    </div>
                </ng-template>
            </div>

            <ng-template #shimmer>
                <div class="white">
                    <div class="shimmer-container min-w-full">
                        <div class="shimmer mb-24">
                            <div class="shimmer-card rounded animate"></div>
                        </div>
                        <div class="shimmer">
                            <div class="shimmer-card table rounded animate mb-8"></div>
                            <div class="shimmer-card table rounded animate"></div>
                        </div>
                    </div>
                </div>
            </ng-template>
        </mat-step>
    </mat-horizontal-stepper>
</div>

<div mat-dialog-actions class="pt-16 action-buttons" fxLayout="row" fxLayoutAlign="space-between center">
    <app-white-button *ngIf="shouldShowBookUsersButton" [label]="'PROGRAM_STRUCTURE.BUTTON.EDIT_PROGRAM_STRUCTURE'" (onClick)="editProgramStructure()"></app-white-button>

    <div fxLayout="row" fxLayoutAlign="end center" class="w-100-p">
        <app-white-button class="mr-8" [label]="'GENERAL.BUTTON.CANCEL'" (onClick)="dialogRef.close(false)"></app-white-button>

        <app-flat-button *ngIf="shouldShowNextButton" [label]="'GENERAL.BUTTON.NEXT'" class="mr-8" [disabled]="!list.length" (onClick)="goForward(stepper)"></app-flat-button>

        <app-flat-button
            *ngIf="shouldShowBookUsersButton"
            [label]="'PAGE.DIALOG.ADD_PROGRAM_PARTICIPANTS.LABEL.BOOK_USERS' | translate: { participantsCount: list.length, executionsCount: selectedExecutionIds.length }"
            class="mr-8"
            [disabled]="!list.length"
            (onClick)="goForward(stepper)"
        ></app-flat-button>

        <!-- Save button for the final step -->
        <app-flat-button *ngIf="shouldShowSaveButton" [label]="'GENERAL.BUTTON.SAVE'" [disabled]="0 === list.length" (onClick)="saveSelected()"></app-flat-button>
    </div>
</div>
